import React, { Component } from 'react';
import { IArticle } from '../../../actions/DataServiceEntities.g';
import { getRichTextHtml } from '@msdyn365-commerce/core';
import { ILobasArticleResources } from '../lobas-article.props.autogenerated';
import classNames from 'classnames';
import * as Msdyn365 from '@msdyn365-commerce/core';
import LobasImageList from './lobas-image-list';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

export interface IArticleViewProps {
    article: IArticle;
    locale: string;
    resources: ILobasArticleResources;
    className: string;
    context: Msdyn365.ICoreContext;
}

class ArticleView extends Component<IArticleViewProps> {
    private fixDateFormat(date: Date | undefined): String {
        if (!date) {
            return '';
        }

        const length = 10;
        return new Date(date).toLocaleDateString(this.props.locale).substring(0, length);
    }

    public render() {
        // const imagecontainer = this.renderImageSection();
        if (this.props.article) {
            return (
                <div className={classNames(this.props.className, 'articleView')}>
                    <h2 className='articleViewTitle'>{this.props.article.Title}</h2>
                    <div className='articleViewDateContainer'>
                        <span className='articleViewDateText'>{`${this.props.resources.articlePublishedDate} `}</span>
                        <span className='articleViewDate'>{`${this.fixDateFormat(this.props.article.DateReleased)}`}</span>
                    </div>
                    <div className='articleRowKeywordsContainer'>
                        {this.props.article.Keywords?.split(',').map(kw => (
                            // eslint-disable-next-line react/jsx-key
                            <h4 className='articleRowKeyword'>{kw}</h4>
                        ))}
                    </div>
                    {/* <img className='articleViewImage' src={this.props.article.ThumbnailImage}></img> */}
                    <div className='articleViewContent' dangerouslySetInnerHTML={getRichTextHtml(this.props.article.Content)}></div>
                    {this.renderImageSection()}
                </div>
            );
        } else {
            return <></>;
        }
    }

    private renderImageSection() {
        const images: Msdyn365.IImageData[] = ArrayExtensions.hasElements(this.props.article.MediaLocations)
            ? this.props.article.MediaLocations?.map(mediaLocation => {
                  return {
                      src: mediaLocation.Url
                  };
              })
            : [];

        return <LobasImageList images={images} resources={this.props.resources} context={this.props.context} />;
    }
}

export default ArticleView;
